module.exports = __webpack_public_path__ + "img/usdt.925a8758.png";